var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5553_66629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 44C44 19.7 63.7 0 88 0C88 24.3 68.3 44 44 44ZM44 44C44 19.7 24.3 0 0 0C0 24.3 19.7 44 44 44ZM0 44C0 68.3 19.7 88 44 88C44 63.7 24.3 44 0 44ZM44 88C68.3 88 88 68.3 88 44C63.7 44 44 63.7 44 88Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5553_66629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon_04.b36803241b3409664b20cfe5ab3bca60.svg";
export { ForwardRef as ReactComponent };